export default __webpack_public_path__ + "static/media/sitebanner.2a298a40.jpg";